

// order stats and params rendering
//var order;
function renderOrder(input) {
  //order = input;

  var data = {order:input};
  $('#orderHeader').html(Handlebars.templates["orders/client_detail_header.html"](data));
  $('#orderParameters').html(Handlebars.templates["orders/client_detail_parameters.html"](data));
  $('#orderStats').html(Handlebars.templates["orders/client_detail_stats.html"](data));
  //$('#orderSummary').html(Handlebars.templates["orders/client_detail_summary.html"](data));

}




var orderHeader = $('#orderStatsHeader')

function setOrderStatusColor(data) {
  if(data.order_status_state=="Open") {
    if (data.order_type=="smart stop" & !data.stop_triggered) {
      orderHeader.attr('class', 'card-header card-header-inverse card-header-info');

    } else {
      orderHeader.attr('class', 'card-header card-header-inverse card-header-success');
    }

  } else if (data.order_status_state=="Open (pending)") {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-warning');

} else if (data.order_status_state=="Staged") {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-warning');

  }  else if (data.order_status_state=="Open (crashed)") {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-danger');

  } else if (data.order_status_state=="Closed") {
    orderHeader.attr('class', 'card-header ');

  } else if (data.order_status_state=="Cancelled") {
    orderHeader.attr('class', 'card-header ');

  } else if (data.order_status_state == "Cancelled (pending)") {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-warning');

  } else if (data.order_status_state=="Error") {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-danger');

  } else if (data.order_status_state=="Closed") {
    orderHeader.attr('class', 'card-header card-header-secondary');
  }

}

class ClientOrderDetailController {

  constructor(orderId, sorTableId='#sorOrders', exchangeSummaryTableId='#exchangeSummaryTable') {
    this.orderId = orderId;
    this.sorTableId=sorTableId;
    this.exchangeSummaryTableId = exchangeSummaryTableId;

    this.sorOrderTable = false;

    this.updateOrder().then((data) => {
      console.log("got data from this.updateOrder")
    });
  }

  updateOrder(force) {
    var self = this
    return this.fetchOrder().then((data) => {
      setOrderStatusColor(data);
      renderOrder(data);
      this.orderData = data;
      return data

    }).catch((err) =>  {
      console.log("error")
      console.log(err)
    }).then((data) => {
      if (!this.sorOrderTable) {
        this.sorOrderTable = new SorOrderTable(data, this.sorTableId);
      }
      this.sorOrderTable.refresh(force);

      if (!this.exchangeSummaryTable) {
        this.exchangeSummaryTable = new ExchangeSummaryTable(data, this.exchangeSummaryTableId)
      }
      this.exchangeSummaryTable.refresh(data);

      if (!this.feeSummaryTable) {
        this.feeSummaryTable = new FeeSummaryTable(data, "#feeSummaryTable")
      }
      this.feeSummaryTable.refresh(data);

    });
  }



  fetchOrder() {
    var self = this;
    var orderPromise = new Promise(function(resolve, reject) {

      $.ajax({
                 type: "GET",
                 url: '/api/client_orders/' + self.orderId + '/',
                 success: function(data) {
                   resolve(data);

                 },
                 error: function(data)
                 {
                    throw new Error(data);
                    console.log(data);
                    console.log("error in fetch")
                 }
               });


    });
    return orderPromise
  }

  // used for submitting order reconsile changes
  update_order(pk) {
    var self = this;

    var oid_elem = $("#exchangeOrderId_" + pk)
    var oid = oid_elem.val();
    var url = '/api/sor_orders/' + pk + '/reconcile/'
    var csrftoken = getCookie('csrftoken');

    if (!oid) {
      var data =  {exchange_order_id: null,
                        exchange_error_ack: true}
    } else {
      var data =  {exchange_order_id: oid,
                        exchange_error_ack: true}
    }

    console.log(data);
    $.ajax({
               type: "PATCH",
               url: url,
               dataType: 'json',
               processData: false,
               data: JSON.stringify(data),
               headers: {'X-CSRFToken': csrftoken},
               contentType: 'application/json',

               success: function(data)
               {
                   console.log(data);
                   self.updateOrder(true);
               },
               error: function(data)
               {
                 console.log(data);
                 $(`#exchangeError_${pk} .small`).text(JSON.stringify(data.responseJSON));
                 $('#exchangeError_' + pk).collapse('show');
               }
             });

  }

  // used to reconsile orders flips order to editable
  updateOrderStatus(pk) {

    console.log(this);
    if (!$('#rSwitch').prop('checked')) {
      $('#rSwitch').click();
    };

    //var row = sor_orders_dt.cell( $(this).closest('td') ).row();
    var row = this.sorOrderTable.table.row('#' + pk);
    var data = row.data();
    console.log(data);
    data.exchange_error_ack=false;
    row.data(data);
    row.draw('page');
    row.scrollTo();


  }


  cancel_order(pk) {
    var url = '/api/client_orders/' + pk + '/cancel/';
    var csrftoken = getCookie('csrftoken');
    var self = this;
    $.ajax({
               type: "POST",
               url: url,
               data: {},
               headers: {'X-CSRFToken': csrftoken},
               success: function(data)
               {
                   self.updateOrder(true);
               },
               error: function(data)
               {
                   console.log(data);
                   console.log("error in cancel")
                   location.reload(true);
               }
             });
    }

send_staged_order(pk) {
  var url = '/api/client_orders/' + pk + '/';
  var csrftoken = getCookie('csrftoken');
  var self = this;
  $.ajax({
             type: "PATCH",
             url: url,
             data: {order_status: "open"},
             headers: {'X-CSRFToken': csrftoken},
             success: function(data)
             {
                 console.log("sent staged order")
                 self.updateOrder(true);
             },
             error: function(data)
             {
                 console.log(data);
                 console.log("error in cancel")
                // location.reload(true);
             }
           });
  }


}

// function refreshOrder(force) {
//   updateOrder().then((data) => {
//      setOrderStatusColor(data);
//      clientOrderSummaryTable.refresh(data);
//   }).catch((err) =>  {
//     console.log("error in refresh order")
//     console.log(err)
//   });
//
//   if (orderTable) {
//     orderTable.refresh(force);
//   }
// }
